import { _n, sprintf } from '@wordpress/i18n';

/**
 * Фільтр номерів за крилом (сторінка «Номери»).
 *
 * Клієнтський: усі номери вже в DOM (їх мало), тому фільтр просто ховає
 * зайві рядки — без перезавантаження й без запитів на сервер.
 */
export default function roomsFilter() {
	const chips = document.querySelectorAll('.chip[data-wing]');
	const rows = document.querySelectorAll('.room-row[data-wing]');
	const count = document.querySelector('.filterbar__count');

	if (!chips.length || !rows.length) return;

	const apply = (wing) => {
		let visible = 0;

		rows.forEach((row) => {
			const match = wing === 'all' || row.dataset.wing === wing;
			row.hidden = !match;
			if (match) visible++;
		});

		// Плюралізацію («номер / номери / номерів») бере на себе _n — форми
		// задає Plural-Forms у .po/.mo, тому ручний підрахунок більше не потрібен.
		if (count) {
			count.textContent = sprintf(
				_n('%d room', '%d rooms', visible, 'hotel'),
				visible
			);
		}
	};

	chips.forEach((chip) => {
		chip.addEventListener('click', () => {
			chips.forEach((c) => c.setAttribute('aria-pressed', 'false'));
			chip.setAttribute('aria-pressed', 'true');
			apply(chip.dataset.wing);
		});
	});
}
